import { render, staticRenderFns } from "./journal_slides.vue?vue&type=template&id=9028b1cc"
import script from "./journal_slides.vue?vue&type=script&lang=js"
export * from "./journal_slides.vue?vue&type=script&lang=js"
import style0 from "./journal_slides.vue?vue&type=style&index=0&id=9028b1cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports